module.exports = __webpack_public_path__ + "img/logo.7c8ffc5c.png";